export default "__VITE_ASSET__BJcNACdy__"